import type React from "react"
import { RiSearchLine, RiFilter3Line } from "react-icons/ri"
import "@/styles/TopSearchBar.css"

const TopSearchBar: React.FC = () => {
  return (
    <div className="top-search-bar-container">
      <div className="search-bar-wrapper">
        <div className="search-input-container">
          <input type="text" placeholder="검색..." className="search-input" />
          <RiSearchLine className="search-icon" />
        </div>
        <button className="filter-button">
          <RiFilter3Line />
        </button>
      </div>
    </div>
  )
}

export default TopSearchBar
